import React, { useState } from 'react';
import { motion } from "framer-motion";
import Header from "../header/Header.jsx";
import AppSidebar from '../sidebar/Sidebar.jsx';

export default function AppLayout({ children, title = process.env.REACT_APP_SITE_NAME }) {

  const [collapsed, setCollapsed] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div>
      <div className='flex'>
        <motion.div className='hidden lg:block' animate={{ marginLeft: collapsed ? "0px" : "-250px", transition: { duration: 0.5 } }}>
          <AppSidebar />
        </motion.div>
        <div className={`bg-bgColor lg:ml-[250px] ${collapsed ? 'lg:w-[calc(100%-250px)]' : 'lg:w-full'} w-full min-h-screen`} >
          <Header collapsed={collapsed} title={title} setCollapsed={setCollapsed} isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
          <div className='p-2 md:p-4'>
            {children}
          </div>
        </div>
        {isDrawerOpen && (
          <motion.div
            initial={{ scale: 0, x: "-99%", y: "-99%" }}
            animate={{ scale: 1, x: 0, y: 0, transition: { duration: 0.3 } }}
            className="fixed top-0 left-0 bg-[#00000040] shadow-blue-gray-900/10 xl:hidden w-full z-10 h-screen max-h-full"
          >
            <div className="bg-white w-[250px] h-screen">
              <AppSidebar />
            </div>
            <div
              className="fixed left-[255px] top-[10px]"
              onClick={() => setIsDrawerOpen(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-6 h-6 cursor-pointer"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  )
}